function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M14,30a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56,23.82H8a4,4,0,0,0-4,4v8.36a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V27.82A4,4,0,0,0,56,23.82Zm0,12.36H8V27.82H56Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16,12.12a2,2,0,1,1-2-2A2,2,0,0,1,16,12.12Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M41,8V7h6V4H8A4,4,0,0,0,4,8V16.3a4,4,0,0,0,4,4H47V17H41v-.7H8V8Zm16,9v3.18A4,4,0,0,0,60,17ZM57,4.08V7h2.92A4,4,0,0,0,57,4.08Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M14,50a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56,43.7H8a4,4,0,0,0-4,4V56a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V47.7A4,4,0,0,0,56,43.7ZM56,56H8V47.7H56Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M41,11.38v1.5H20.12a.75.75,0,0,1,0-1.5Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M51.87,32.75H20.12a.75.75,0,0,1,0-1.5H51.87a.75.75,0,1,1,0,1.5Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M51.87,52.79H20.12a.75.75,0,1,1,0-1.5H51.87a.75.75,0,0,1,0,1.5Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M56,16.3h0V16h0ZM56,8V8h0V8Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56,8V2H48V8H42v8h6v6h8V16h6V8ZM44,14V10h6V4h4v6h6v4H54v6H50V14Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M56,16v.3h0V16Zm0-8V8h0V8Z"
});

var SvgDatabasePlus = function SvgDatabasePlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDatabasePlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Database_Plus.d27cd17a.svg";
export { ForwardRef as ReactComponent };